<template>
  <j-form-container :disabled="disabled">
    <a-form :form="form" slot="detail">
      <a-row>
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="合同编码" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input v-decorator="['conCode']" :placeholder="$t('label.pleaseEnterTheContractCode')"></a-input>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="饲养天数" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['breedCycleDays', validatorRules.breedCycleDays]" placeholder="请输入饲养天数" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="合同数量" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['planBreedQty', validatorRules.planBreedQty]" placeholder="请输入合同数量" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="标准成活率（上限）" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['stdSurvivalUp', validatorRules.stdSurvivalUp]" placeholder="请输入标准成活率（上限）" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="标准成活率（下限）" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['stdSurvivalDown', validatorRules.stdSurvivalDown]" placeholder="请输入标准成活率（下限）" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="标准成活率（标准）" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['stdSurvivalAvg', validatorRules.stdSurvivalAvg]" placeholder="请输入标准成活率（标准）" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="次级标准成活率（上限）" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['stdSecSurvivalUp', validatorRules.stdSecSurvivalUp]" placeholder="请输入次级标准成活率（上限）" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="次级标准成活率（下限）" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['stdSecSurvivalDown', validatorRules.stdSecSurvivalDown]" placeholder="请输入次级标准成活率（下限）" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="次级标准成活率（标准）" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['stdSecSurvivalAvg', validatorRules.stdSecSurvivalAvg]" placeholder="请输入次级标准成活率（标准）" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="标准体重（上限）" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['stdWeightUp', validatorRules.stdWeightUp]" placeholder="请输入标准体重（上限）" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="标准体重（下限）" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['stdWeightDown', validatorRules.stdWeightDown]" placeholder="请输入标准体重（下限）" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="标准体重（标准）" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['stdWeightAvg', validatorRules.stdWeightAvg]" placeholder="请输入标准体重（标准）" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="标准均匀度（上限）" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['stdEvennessUp', validatorRules.stdEvennessUp]" placeholder="请输入标准均匀度（上限）" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="标准均匀度（下限）" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['stdEvennessDown', validatorRules.stdEvennessDown]" placeholder="请输入标准均匀度（下限）" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="标准均匀度（标准）" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['stdEvennessAvg', validatorRules.stdEvennessAvg]" placeholder="请输入标准均匀度（标准）" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="单只耗用量（上限）" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['stdConsumeUp', validatorRules.stdConsumeUp]" placeholder="请输入单只耗用量（上限）" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="单只耗用量（下限）" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['stdConsumeDown', validatorRules.stdConsumeDown]" placeholder="请输入单只耗用量（下限）" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="单只耗用量（标准）" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['stdConsumeAvg', validatorRules.stdConsumeAvg]" placeholder="请输入单只耗用量（标准）" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="标准料肉比（上限）" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['stdFeedMeatUp', validatorRules.stdFeedMeatUp]" placeholder="请输入标准料肉比（上限）" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="标准料肉比（下限）" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['stdFeedMeatDown', validatorRules.stdFeedMeatDown]" placeholder="请输入标准料肉比（下限）" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="标准料肉比（标准）" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['stdFeedMeatAvg', validatorRules.stdFeedMeatAvg]" placeholder="请输入标准料肉比（标准）" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="保证金单价" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['depositPrice', validatorRules.depositPrice]" placeholder="请输入保证金单价" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="保证金金额" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input v-decorator="['depositAmount', validatorRules.depositAmount]" placeholder="请输入保证金金额"></a-input>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item :label="$t('label.marginBalance')" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input v-decorator="['depositBalance', validatorRules.depositBalance]" placeholder="请输入保证金余额"></a-input>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="禽苗成本 元/只" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['chickCost', validatorRules.chickCost]" placeholder="请输入禽苗成本 元/只" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="饲喂成本 元/只" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['feedCost', validatorRules.feedCost]" placeholder="请输入饲喂成本 元/只" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="药品成本 元/只" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['drugCost', validatorRules.drugCost]" placeholder="请输入药品成本 元/只" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="其他成本 元/只" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['othersCost', validatorRules.othersCost]" placeholder="请输入其他成本 元/只" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="结算依据" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input v-decorator="['stlAccording']" placeholder="请输入结算依据"></a-input>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="养户" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input v-decorator="['farmerCode']" placeholder="请输入养户"></a-input>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="盈利比例甲方" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['paProfitRatio', validatorRules.paProfitRatio]" placeholder="请输入盈利比例甲方" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="盈利比例乙方" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['pbProfitRatio', validatorRules.pbProfitRatio]" placeholder="请输入盈利比例乙方" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="亏损比例甲方" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['paLossRatio', validatorRules.paLossRatio]" placeholder="请输入亏损比例甲方" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="亏损比例乙方" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['pbLossRatio', validatorRules.pbLossRatio]" placeholder="请输入亏损比例乙方" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="结算金额甲方" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['paStlAmount', validatorRules.paStlAmount]" placeholder="请输入结算金额甲方" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <!--          <a-col :span="6">-->
        <!--            <a-form-item label="结算金额乙方" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--              <a-input-number v-decorator="['pbStlAmount', validatorRules.pbStlAmount]" placeholder="请输入结算金额乙方" style="width: 100%"/>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->
        <a-col :span="24">
          <!--label="备注"-->
          <a-form-item :label="$t('label.remarks')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <!-- <a-textarea v-decorator="['remark']" rows="4" placeholder="请输入备注"></a-textarea> -->
            <mtc-lang-popover :whetherLang="whetherLang('remark')" :popLists="getMainTablePop('remark')">
              <a-textarea
                rows="4"
                v-decorator="['remark']"
                :read-only="whetherLang('remark')"
                @click="isLangClick('remark', false)"
                :placeholder="$t('label.pleaseEnterANote')"
              ></a-textarea>
            </mtc-lang-popover>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item v-has="'buffer6'" :label="$t('label.remarks')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <!-- <a-input v-decorator="['buffer6',{'initialValue': '1'}]" placeholder="请输入备注"></a-input> -->
            <mtc-lang-popover :whetherLang="whetherLang('buffer6')" :popLists="getMainTablePop('buffer6')">
              <a-input
                v-decorator="['buffer6', { initialValue: '1' }]"
                :read-only="whetherLang('buffer6')"
                @click="isLangClick('buffer6', false)"
                :placeholder="$t('label.pleaseEnterANote')"
              ></a-input>
            </mtc-lang-popover>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <!-- <mtc-lang-modal/> -->
  </j-form-container>
</template>
<script>
import pick from 'lodash.pick'
import { getAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import JFormContainer from '@/components/jeecg/JFormContainer'
// import { mtcLangModalMixin } from '@/mixins/mtcLangModalMixin'
import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'

export default {
  name: 'EfsMdContractDetailForm',
  mixins: [JEditableTableMixin],
  // mixins: [JEditableTableMixin],
  components: {
    JFormContainer,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    // 当前table对应的数据表名
    mainTable: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // mainTable: 'efs_md_contract_detail',
      // form: this.$form.createForm(this),
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
      validatorRules: {},
      confirmLoading: false,
      sonSysLanguageList: []
    }
  },
  methods: {
    initFormData(url, id) {
      this.clearFormData()
      if (!id) {
        this.edit({})
      } else {
        getAction(url, { id: id }).then((res) => {
          if (res.success) {
            let records = res.result
            if (records && records.length > 0) {
              this.edit(records[0])
            }
          }
        })
      }
    },
    edit(record) {
      this.model = Object.assign({}, record)
      console.log('EfsMdContractDetailForm-edit', this.model)
      let fieldval = pick(this.model, 'remark', 'buffer6')
      let langReturn = []
      this.$nextTick(() => {
        this.form.setFieldsValue(fieldval)
        // this.sonSysLanguageList = JSON.parse(JSON.stringify(record.sysLanguageList))
        // console.log('mainTableAllLangLists---', this.mainTableAllLangLists)
        // if(this.mainTableAllLangLists)
        langReturn = this.mainTableAllLangLists.concat(record.sysLanguageList)
        this.$bus.$emit('mainlanguageLists', langReturn)
      })
    },
    getFormData() {
      let formdata_arr = []
      this.form.validateFields((err, values) => {
        if (!err) {
          let formdata = Object.assign(this.model, values)

          // 处理主表多语言数据--begin
          this.sysLanguageList = []
          for (const key in this.mainTableLangLists) {
            // 将数组对象展开
            for (let i = 0; i < this.mainTableLangLists[key].length; i++) {
              this.sysLanguageList.push(this.mainTableLangLists[key][i])
            }
          }
          this.$set(formdata, 'sysLanguageList', this.sysLanguageList)
          // 处理主表多语言数据--over
          let isNullObj = true
          Object.keys(formdata).forEach((key) => {
            if (formdata[key]) {
              isNullObj = false
            }
          })
          if (!isNullObj) {
            formdata_arr.push(formdata)
          }
        } else {
          this.$emit('validateError', '合同明细表单校验未通过')
        }
      })
      console.log('合同明细表单数据集', formdata_arr)
      return formdata_arr
    },
    popupCallback(row) {
      this.form.setFieldsValue(pick(row, 'remark', 'buffer6'))
    },
    clearFormData() {
      this.form.resetFields()
      this.model = {}
    },
  },
}
</script>
